module.exports = __webpack_public_path__ + "static/media/cellfinate_antes_despues_1.e392b936.jpg";